import { Redirect } from "expo-router";

export default function OnboardingIndexWeb() {
    return <Redirect href="/" />;
} 